module.exports = __webpack_public_path__ + "img/close-gray.bcb381ad.svg";